import { createUseStyles } from 'react-jss';

const useGlobalStyles = createUseStyles((theme) => ({
  '@global': {
    '[data-rsbs-root]': {
      '--rsbs-backdrop-bg': 'rgba(0, 0, 0, 0.16)',
      '--rsbs-overlay-rounded': '8px !important',
      '--rsbs-handle-bg': theme.palette.secondaryLighter,
    },
  },
}));

export default useGlobalStyles;
